var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { mortgageData, templates } = options;  
__p+='\n\n<li id="mortgage_insurance_field" class="'+
((__t=( mortgageData.monthly_mortgage_insurance_class ))==null?'':__t)+
'">\n  <i class="ra ra-circle legend-mortg-insurance icon-space-right"></i> Mortgage Insurance<span id="mortgage_insurance" class="float-right">'+
((__t=( mortgageData.monthly_mortgage_insurance ))==null?'':__t)+
'</span>\n</li>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/payment/legend/insurance-field.jst.ejs